var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert alert-danger"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"alert-icon"},[_c('md-icon',[_vm._v("info_outline")])],1),_vm._v(" Mütləq sahə! ")])])}
var staticRenderFns = []

export { render, staticRenderFns }